import { PROCESS_TYPE_REQUEST, CREATE_PROCESS_TYPE, GET_PROCESS_TYPE, UPDATE_PROCESS_TYPE, DELETE_PROCESS_TYPE, 
PROCESS_TYPE_REQUEST_FAILURE, PROCESS_TYPE_REQUEST_SUCCESS, GET_PROCESS_TYPE_PAGE } from '../types';

const initialState = {
  processTypes: [],
  processTypePage: [],
  loading: false,
  error: null,
};

const processTypesReducer = (state = initialState, action) => {
  switch (action.type) {
    case PROCESS_TYPE_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_PROCESS_TYPE: {
      return {
        ...state,
        processTypes: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_PROCESS_TYPE_PAGE: {
      const { data, total, page, pageSize, search, where } = action.payload || {};  
      console.log('data<<--', data)    ;
      return {
        ...state,
        processTypePage: [...data],
        total,
        page,
        pageSize,
        search: search || '',
        where: where || {},
        loading: false,
        error: null
      }
    }
    case CREATE_PROCESS_TYPE:
      return {
        ...state,
        processTypes: [action.payload, ...state.processTypes],
        loading: false,
        error: null
      };
    case UPDATE_PROCESS_TYPE:
      const processTypeData = state.processTypes.slice(0);
      const uIndex = processTypeData.findIndex((data) => data.id === action.payload.id);
      processTypeData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        processTypes: [ ...processTypeData ],
        loading: false,
        error: null
      };
    case DELETE_PROCESS_TYPE:
      const processType = state.processTypes?.slice(0);
      const index = processType.findIndex((data) => data.id === action.id);
      if (index > -1) {
        processType.splice(index, 1);
      }
      return {
        ...state,
        processTypes: [...processType],
        loading: false,
        error: null
      }
    case PROCESS_TYPE_REQUEST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null
      }
    }
    case PROCESS_TYPE_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default processTypesReducer;
